import type { Paginated, PaginationQuery } from "@/configs/request";
import type { AdminInvitation, InvitationStatus, MeetingFormat, SortOrder } from "@/types";

import { BaseApi } from "./base.api";

/** Serverda saralanadigan ustunlar — backenddagi ro'yxat bilan bir xil. */
export type AdminInvitationSortField =
  "createdAt" | "answeredAt" | "slotStartAt" | "coffees" | "priceUzs";

export interface AdminInvitationFilter extends PaginationQuery {
  /**
   * Ism yoki Telegram username. Ikki tomon ALOHIDA qidiriladi:
   * jadvalda ikkalasi ham o'z ustunida turadi.
   */
  guest?: string;
  host?: string;
  status?: InvitationStatus;
  format?: Exclude<MeetingFormat, "both">;
  durationMinutes?: number;
  coffees?: number;
  /** So'mdagi summa. Qahva soni va joriy narx ko'paytmasiga solishtiriladi. */
  priceUzs?: number;
  hostId?: string;
  guestId?: string;
  /** Yuborilgan vaqt oralig'i, ISO 8601. */
  createdFrom?: string;
  createdTo?: string;
  /** Javob vaqti: qabul qilingan, u bo'lmasa yopilgan payt. */
  answeredFrom?: string;
  answeredTo?: string;
  /** Uchrashuv vaqti. */
  slotFrom?: string;
  slotTo?: string;
  sortBy?: AdminInvitationSortField;
  sortOrder?: SortOrder;
}

class AdminInvitationsApi extends BaseApi {
  private readonly baseUrl = "/admin/invitations";

  list(filter: AdminInvitationFilter = {}) {
    return this.request<Paginated<AdminInvitation>>(this.baseUrl, { query: { ...filter } });
  }

  /**
   * Bitta taklif — uchrashuv kartochkasining asosi.
   *
   * Ro'yxatdan qatorni olib qo'ya olmaymiz: moderator kartochkani
   * havola bo'yicha ham ochadi (bildirishnomadan, foydalanuvchi
   * kartochkasidan), va o'shanda ro'yxat umuman yuklanmagan bo'ladi.
   */
  detail(id: string) {
    return this.request<AdminInvitation>(`${this.baseUrl}/${id}`);
  }

  /**
   * Moderator taklifni bekor qiladi.
   *
   * Qahva mehmonga TO'LIQ qaytadi: kech bekor qilish tovoni
   * olinmaydi, chunki tovon mehmonning kechikkani uchun va bu
   * yerda mehmon hech narsa qilmagan.
   *
   * Sabab MAJBURIY — u audit jurnaliga va ledger yozuvining
   * izohiga tushadi, ikkalasi ham o'chirilmaydi.
   */
  cancel(id: string, reason: string) {
    return this.request<AdminInvitation>(`/admin/invitations/${id}/cancel`, {
      method: "POST",
      body: { reason },
    });
  }
}

export const adminInvitationsApi = new AdminInvitationsApi();
